/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { IAgentPlugin, IPluginMethodMap } from '@vlinder-web/plugin-agent-service-react';
import config from '../config/RecallList.config.json';
import member from '../config/memberDetail.config.json';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { VApplication } from '../../../application';
import { GET_Recall_LIST } from '../graphql/recallCommiteeDisc.query';
import { pretty } from '@vlinder-web/utils-react';
import { GET_MY_PROFILE } from '../graphql';

const is = require('is_js');
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export interface ISingleRecallMethods extends IPluginMethodMap {
  getSingleRecallProps(args: any): Promise<any>;
}

export class SingleRecallService implements IAgentPlugin {
  readonly methods: ISingleRecallMethods;

  constructor() {
    this.methods = {
      getSingleRecallProps: this.getSingleRecallProps.bind(this),
    };
  }

  async getSingleRecallProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient('graphql-gateway');
    console.log(args)

    try {
      if (client) {
        const _res = await client.query({
          query: GET_MY_PROFILE,
          fetchPolicy: "network-only",
        });
        let filter: any = {
          committeeId: _res?.data?.getMyProfile?.id,
        }
        const res = await client.query({
          query: GET_Recall_LIST,
          variables: filter,
          fetchPolicy: 'network-only',
        });
        if (res?.data) {
          let result = res?.data?.getCommitteeDiscounts;
          const rows = this.formatUserTable(result);
          console.log("res_data==>", pretty(rows));
          return {
            ...config,
            ultUsers: rows,
            isEmpty: rows.length <= 0,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
    return { ...(config || {}) };
  }

  private formatUserTable(result: any) {
    let rows: any[] = [];
    result.forEach((item?: any) => {
      let assignedToCommittee = item?.statusCounts?.find((item: any) => item.status === "AssignedToCommittee") ?? 0;
      let PurchasedCommittee = item?.statusCounts?.find((item: any) => item.status === "Purchased") ?? 0;
      let SentToMasqCommittee = item?.statusCounts?.find((item: any) => item.status === "SentToMasq") ?? 0;
      rows.push({
        _id: item?.discounts?._id ?? '-',
        totalCount: item?.totalCount,
        name: item?.discounts?.name ?? item?.discounts?.prefix ?? "-",
        assignedTo: assignedToCommittee?.count ?? 0,
        purchased: PurchasedCommittee?.count ?? 0,
        SentToMasq: SentToMasqCommittee?.count ?? 0,
        remaining: assignedToCommittee?.count ?? 0,
      })
    })
    return rows;
  }
}
